export class VersionConflictError extends Error {
  constructor(public currentVersion: number | null) {
    super(
      `Conflito de versão. Versão atual no servidor: ${currentVersion ?? "desconhecida"}`,
    );
    this.name = "VersionConflictError";
  }
}
